import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ParcelDetails, Result } from '@lanterds/types';

import DetailLayout from 'src/components/Layouts/DetailLayout/DetailLayout';
import SidebarContent from './SidebarContent/SidebarContent';
import MainDetailContent from './MainDetailContent/MainDetailContent';
import LoadingIndicator from 'src/components/common/LoadingIndicator/LoadingIndicator';
import api from 'src/api';

import './ParcelDetailView.scss';
import { Card, CardContent } from '@mui/material';

export default function ParcelDetailView() {
    const { barcode: rawBarcode, date: rawDate, customerId: rawCustomerId, endpointName: rawEndpointName } = useParams();

    const barcode = rawBarcode ? decodeURIComponent(rawBarcode) : '';
    const date = rawDate ? decodeURIComponent(rawDate) : '';
    const customerId = rawCustomerId ? decodeURIComponent(rawCustomerId) : '';
    const endpointName = rawEndpointName ? decodeURIComponent(rawEndpointName) : '';

    const [isLoading, setIsLoading] = useState(false);
    const [parcel, setParcel] = useState<ParcelDetails>();

    /**
     * If we throw the error inside of the callback of the getParcelDetails Call,
     * the context for that throw will be the anonymous callback. This means the error
     * gets thrown into oblivion. Instead, we set it to this state variable and check it below
     * so we can throw it in the context of the rendering of the component. In that situation
     * the error is caught by the errorComponent defined in the router.
     */
    const [apiError, setApiError] = useState<null | Error>(null);

    useEffect(() => {
        if (barcode && date && customerId && endpointName) {
            setIsLoading(true);

            api.parcel
                .getParcelDetails(barcode, new Date(date), customerId, endpointName)
                .then((results: Result<ParcelDetails>) => {
                    const { data, error } = results;

                    if (data) {
                        setParcel(data);
                    } else if (error) {
                        console.error(error);
                        setApiError(error);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setApiError(error);
                })
                .finally(() => setIsLoading(false));
        }
    }, [barcode, date, customerId, endpointName]);

    if (apiError) throw apiError;

    return (
        <Card className="parcel-detail">
            <CardContent>
                {isLoading && <LoadingIndicator />}

                {!isLoading && parcel && (
                    <DetailLayout
                        sidebarContent={<SidebarContent logoUrl={parcel?.logoUrl} parcelInfo={parcel?.generalParcelInfo} />}
                        primaryContent={<MainDetailContent parcel={parcel} />}
                    />
                )}
            </CardContent>
        </Card>
    );
}
